var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorrectSound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#434343"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2511 15.9759C10.7191 15.9759 10.2571 15.8873 9.86506 15.7099C9.47306 15.5326 9.16972 15.2806 8.95506 14.9539C8.74039 14.6179 8.63306 14.2306 8.63306 13.7919C8.63306 13.3719 8.72639 12.9986 8.91306 12.6719C9.09972 12.3359 9.38906 12.0559 9.78106 11.8319C10.1731 11.6079 10.6677 11.4493 11.2651 11.3559L13.7571 10.9499V12.3499L11.6151 12.7139C11.2511 12.7793 10.9804 12.8959 10.8031 13.0639C10.6257 13.2319 10.5371 13.4513 10.5371 13.7219C10.5371 13.9833 10.6351 14.1933 10.8311 14.3519C11.0364 14.5013 11.2884 14.5759 11.5871 14.5759C11.9697 14.5759 12.3057 14.4966 12.5951 14.3379C12.8937 14.1699 13.1224 13.9413 13.2811 13.6519C13.4491 13.3626 13.5331 13.0453 13.5331 12.6999V10.7399C13.5331 10.4133 13.4024 10.1426 13.1411 9.92793C12.8891 9.70393 12.5531 9.59193 12.1331 9.59193C11.7411 9.59193 11.3911 9.69926 11.0831 9.91393C10.7844 10.1193 10.5651 10.3946 10.4251 10.7399L8.92706 10.0119C9.07639 9.61059 9.30972 9.26526 9.62706 8.97593C9.95372 8.67726 10.3364 8.44393 10.7751 8.27593C11.2137 8.10793 11.6897 8.02393 12.2031 8.02393C12.8284 8.02393 13.3791 8.14059 13.8551 8.37393C14.3311 8.59793 14.6997 8.91526 14.9611 9.32593C15.2317 9.72726 15.3671 10.1986 15.3671 10.7399V15.8079H13.6311V14.5059L14.0231 14.4779C13.8271 14.8046 13.5937 15.0799 13.3231 15.3039C13.0524 15.5186 12.7444 15.6866 12.3991 15.8079C12.0537 15.9199 11.6711 15.9759 11.2511 15.9759Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrectSound);
export default __webpack_public_path__ + "static/media/correct-sound.143c8d4ac9c051a71f19c1b84b32e66b.svg";
export { ForwardRef as ReactComponent };